import { useMemo } from 'react';
import getCookie from '../helper/getCookie';

export default function useAuth() {
  const existsJWT = getCookie('jwt_token_ellon_sports');

  const isAuthenticated = useMemo(() => {
    if (!existsJWT) {
      return false;
    }

    return true;
  }, [existsJWT]);

  return isAuthenticated;
}
